import * as React from 'react';

import { cn } from 'shared/lib/utils';

const DOT_DELAYS = [
  '[animation-delay:0s]',
  '[animation-delay:0.2s]',
  '[animation-delay:0.4s]',
];

function LoadingDots({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      role="status"
      aria-label="Loading"
      data-slot="loading-dots"
      className={cn('inline-flex items-center gap-1 py-1', className)}
      {...props}
    >
      {DOT_DELAYS.map((delay) => (
        <span
          key={delay}
          data-slot="loading-dot"
          className={cn(
            'size-3 animate-loading-dots rounded-full bg-current',
            delay
          )}
        />
      ))}
    </div>
  );
}

export { LoadingDots };
